import * as React from 'react';

import Frame from '../Frame';
import type { EmbedProps } from '.';

function Loom(props: EmbedProps) {
  const normalizedUrl = props.attrs.href.replace('share', 'embed');

  return <Frame {...props} src={normalizedUrl} title="Loom Embed" />;
}

Loom.isMatch = (href: string) => {
  const loomRegex = /^https:\/\/(www\.)?(use)?loom\.com\/(embed|share)\/(.*)$/;

  return loomRegex.test(href);
};

export default Loom;
